import {
	type Fill,
	type Stroke,
	type LineSymbol,
} from "@ptx-autonomous/libs/maplibre";

export const fieldFill: Fill = {
	color: "#c5edda",
	opacity: 0.2,
};

export const fieldStroke: Stroke = {
	color: "#c5edda",
	opacity: 1,
	weight: 2,
};

export const estimatedCoverageFill: Fill = {
	color: "#425adc",
	opacity: 0.15,
};

export const estimatedCoverageStroke: Stroke = {
	color: "#425adc",
	opacity: 1,
	weight: 2,
};

export const pathStroke: Stroke = {
	color: "#ffb366",
	weight: 3,
	opacity: 0.8,
};

export const pathSymbol: LineSymbol = {
	color: "#ffb366",
	spacing: 50,
	minZoom: 16,
	size: 26,
};

export const shortenedSegmentFill: Fill = {
	pattern: "/fill-pattern-red.png",
	opacity: 0.8,
};

export const shortenedSegmentStroke: Stroke = {
	color: "#991c1b",
	opacity: 1,
	weight: 2,
};

export const drivenPathStroke: Stroke = {
	color: "#193490",
	opacity: 1,
	weight: 3,
};

export const coverageStroke: Stroke = {
	color: "#22c55e",
	opacity: 0.5,
	weight: 1,
};

export const coverageFill: Fill = {
	color: "#22c55e",
	opacity: 0.5,
};

export const abLineUnselectedOuterStroke: Stroke = {
	color: "#ffffff",
	weight: 8,
	opacity: 0.95,
};

export const abLineUnselectedInnerStroke: Stroke = {
	color: "#425adc",
	weight: 4,
	opacity: 1,
};

export const abLineSelectedOuterStroke: Stroke = {
	color: "#ffffff",
	weight: 10,
	opacity: 0.95,
};

export const abLineSelectedInnerStroke: Stroke = {
	color: "#0c9f50",
	weight: 6,
	opacity: 1,
};

export const guidanceLineStroke: Stroke = {
	color: "#1cc8f3", // theme-blue-400
	weight: 5,
	opacity: 1,
};

export const guidanceLineSymbol: LineSymbol = {
	color: "#ffffff",
	size: 12,
	spacing: 80,
};

export const speedZoneFill: Fill = {
	color: "#FFBF00",
	opacity: 0.2,
};

export const speedZoneStroke: Stroke = {
	color: "#FFBF00",
	weight: 2,
	opacity: 1,
};

export const noTillZoneFill: Fill = {
	color: "#C83E4D",
	opacity: 0.2,
};

export const noTillZoneStroke: Stroke = {
	color: "#C83E4D",
	weight: 2,
	opacity: 1,
};

export const startingPathStroke: Stroke = {
	color: "#dc2626",
	weight: 3,
	opacity: 1,
};

export const currentObstacleStroke: Stroke = {
	color: "#f97316", // Orange
	weight: 4,
	opacity: 1,
};

export const completedObstacleFill: Fill = {
	color: "#f97316", // Orange
	opacity: 0.3,
};

export const completedObstacleStroke: Stroke = {
	color: "#ea580c", // Dark orange
	weight: 3,
	opacity: 1,
};

export const leftBoundaryStroke: Stroke = {
	color: "#ef4444", // Red (port side)
	weight: 4,
	opacity: 1,
};

export const rightBoundaryStroke: Stroke = {
	color: "#22c55e", // Green (starboard side)
	weight: 4,
	opacity: 1,
};

export const inactiveResumePointStroke: Stroke = {
	color: "#ba4528", // Dark Red
	weight: 4,
	opacity: 1,
	dashArray: [2, 2],
};

export const activeResumePointStroke: Stroke = {
	color: "#ff6105", // PTx Orange
	weight: 4,
	opacity: 1,
	dashArray: [2, 2],
};

export const activeResumePointFill: Fill = {
	color: "#ff6105", // Orange
	opacity: 0.3,
};

export const ResumePointColour = "#ba4528";
